import { Card } from "@mantine/core";
import Minimap from "components/Minimap";
import { FC, memo, ReactNode } from "react";

const MemoizedMiniMap = memo<{
  latLon: [number, number],
  onPinPositionChange?: (p: [number, number]) => void;
}>(({ latLon, onPinPositionChange } ) => (
    <Minimap
      latLon={latLon}
      h={180}
      onPinPositionChange={onPinPositionChange}
    />
  ), (prevProps, nextProps) =>
    prevProps.latLon[0] === nextProps.latLon[0] &&
    prevProps.latLon[1] === nextProps.latLon[1]
  );

interface Props {
  children: ReactNode;
  i?: string;
  selected?: boolean;
  selectedColor?: string;
  latLon?: [number, number];
  onPinPositionChange?: (p: [number, number]) => void;
}

const GeoCard: FC<Props> = ({ 
  selectedColor = "#4F7D9C",
  i,
  children, 
  selected,
  latLon,
  onPinPositionChange,
}) => {
  return (
    <Card
      withBorder
      padding="md"
      radius="lg"
      mb="md"
      styles={{
        root: {
          borderColor: selected ? selectedColor : "var(--paper-border-color)",
          borderWidth: "2px",
        }
      }}>
      {children}
      {latLon && (
        <Card.Section>
          <MemoizedMiniMap 
            latLon={latLon} 
            onPinPositionChange={onPinPositionChange} />
        </Card.Section>
      )}
    </Card>
  );
};

export default GeoCard;